import { useState, useEffect } from 'react';
import { requestGet } from '@/common/request';
import { LOAD_STATUS } from '@/components/loadable';
import batchedUpdates from '@/common/utils/batched-updates';
import { message } from 'antd';

export enum Type {
  TFCollectionPool = 5, // 投放收品池
}

export interface Query {
  planCode: string; // 主题活动code
  type: Type; // 关联类型
}

export interface ResultData {
  id: string;
  planCode: string;
  type: Type;
  poolId: string;
  name: string;
  createErp: string;
  updateErp: string;
  createTime: number;
  updateTime: number;
  status: number;
}

// 趋势场域关联趋势品类
export default function getByType(query: Query): Promise<RequestResult<ResultData>> {
  return requestGet('/goodsPool/getByType', query);
}

export function useAPIQueryGetByType(initialQuery: Query) {
  const [query, setQuery] = useState<Query>(initialQuery);
  const [state, setState] = useState<ResultData>();
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.FIRST);

  // 获取值
  useEffect(() => {
    setLoadStatus(LOAD_STATUS.ING);
    (async () => {
      try {
        const { ret, data, msg } = await getByType(query);

        if (ret !== '0' || !data) {
          setLoadStatus(LOAD_STATUS.FAILED);
          return message.error(msg);
        }

        batchedUpdates(() => {
          setState(data);
          setLoadStatus(LOAD_STATUS.SUCCESS);
        });
      } catch (ex) {
        console.error(ex);
        setLoadStatus(LOAD_STATUS.FAILED);
        message.error('服务端异常请稍后重试');
      }
    })();
  }, [query]);

  return [{ query, loadStatus, loading: loadStatus === LOAD_STATUS.ING, state }, { setQuery }] as const;
}
